// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck.ck-editor__main > .ck-editor__editable {
  border: 1px solid #d3d3d3 !important;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border: 1px solid #d3d3d3 !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/DynamicForm/formelements/EditorElement.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;;EAEE,oCAAA;AACF","sourcesContent":[".ck.ck-editor__main > .ck-editor__editable {\n  border: 1px solid #d3d3d3 !important;\n}\n\n.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,\n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {\n  border: 1px solid #d3d3d3 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
